<script>
  import { Bar } from 'vue-chartjs'
  import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'

  export default {
    extends: Bar,
    props: {
      label: {
        type: Array
      },
      data: {
        type: Array
      }
    },
    mounted () {
      this.createChart()
    },
    methods: {
      createChart() {
        const brandInfo = getStyle('--info') || '#007096';

        let tableData = {
          labels: this.label,
          datasets: [
            {
              label: 'Modelli generati',
              backgroundColor: hexToRgba(brandInfo, 10),
              borderColor: brandInfo,
              pointHoverBackgroundColor: '#d6ecfb',
              borderWidth: 3,
              data: this.data
            }
          ]
        };

        const options = {
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              type: 'time',
              time: {
                unit: 'day'
              },
              scaleLabel: {
                display: true,
                labelString: 'Date'
              },
              gridLines: {
                drawOnChartArea: false
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                stepSize: Math.ceil(250 / 5)
              },
              gridLines: {
                display: true
              }
            }]
          }
        };

        this.renderChart(tableData, options)
      }
    }
  }
</script>
